import React from "react";

import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const LibraryListSkeleton: React.FC = () => {
  return (
    <>
      {Array(9)
        .fill(0)
        .map((_, index) => (
          <Grid key={index}>
            <Skeleton variant="rounded" width={300} height={200} />
          </Grid>
        ))}
    </>
  );
};
